export default "__VITE_PUBLIC_ASSET__69c69b1b__"